import { useMemo } from 'react';

import {
  useGetFirmQuery,
  useUpdateFirmMutation,
} from '@/services/api/firmsService';
import { Firm } from '@/services/types/firms-types';

/**
 * Hook for fetching and managing a single firm
 */
export function useFirm(firmId: string) {
  const {
    data: firm,
    isLoading,
    error,
    refetch,
  } = useGetFirmQuery(firmId, {
    skip: !firmId,
  });

  const [updateFirmMutation, { isLoading: isUpdating }] =
    useUpdateFirmMutation();

  const updateFirm = async (updates: Partial<Firm>) => {
    if (!firm) {
      throw new Error('Cannot update: Firm not loaded');
    }

    await updateFirmMutation({
      id: firm.id,
      ...updates,
    });
  };

  const result = useMemo(
    () => ({
      firm: firm || null,
      isLoading: isLoading || isUpdating,
      error,
      refetch,
      updateFirm,
    }),
    [firm, isLoading, isUpdating, error, refetch, updateFirm],
  );

  return result;
}
